export type PostCustomerContractApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCustomerContractApiArg = {
  body: {
    name: string;
    description?: string | null;
    materialDiscountGroupId?: string | null;
  } | null;
};
export type GetCustomerContractByIdApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      name?: string | null;
      description?: string | null;
      materialDiscountGroupId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractByIdApiArg = {
  customerContractId: string;
};
export type PatchCustomerContractApiResponse = /** status 204 Standard response */ undefined;
export type PatchCustomerContractApiArg = {
  customerContractId: string;
  body: {
    name: string;
    description?: string | null;
    groupId?: string | null;
  } | null;
};
export type DeleteCustomerContractApiResponse = /** status 204 Standard response */ undefined;
export type DeleteCustomerContractApiArg = {
  customerContractId: string;
};
export type VehicleAgeType = 'VEHICLE_AGE_UNDECIDED' | 'VEHICLE_AGE_IN_MONTHS';
export type LabourDiscountType = 'DISCOUNTED_FIXED_RATE' | 'PERCENTAGE_DISCOUNT';
export type PostCustomerContractLabourDiscountApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;

export type PostCustomerContractLabourDiscountApiArg = {
  customerContractId: string;
  body: {
    name: string;
    vehicleMakes?: (string | null)[];
    vehicleModelFamilies?: (string | null)[];
    vehicleModels?: (string | null)[];
    vehicleTypes?: (string | null)[];
    vehicleAgeType: VehicleAgeType;
    vehicleAgeFrom?: number | null;
    vehicleAgeTo?: number | null;
    workTypes?: (string | null)[];
    isServiceOrderVariant?: boolean | null;
    serviceOrderVariantIds?: (string | null)[];
    isDirectSaleVariant?: boolean | null;
    directSaleVariantIds?: (string | null)[];
    discountSettingsType: string;
    discountSettingsValue?: number | null;
  } | null;
};
export type GetCustomerContractLabourDiscountApiResponse =
  | /** status 200 Standard response */ ({
      name?: string | null;
      vehicleMakes?: (string | null)[];
      vehicleModelFamilies?: (string | null)[];
      vehicleModels?: (string | null)[];
      vehicleTypes?: (string | null)[];
      vehicleAgeType?: VehicleAgeType | null;
      vehicleAgeFrom?: number | null;
      vehicleAgeTo?: number | null;
      workTypes?: (string | null)[];
      isServiceOrderVariant?: boolean | null;
      serviceOrderVariantIds?: (string | null)[];
      isDirectSaleVariant?: boolean | null;
      directSaleVariantIds?: (string | null)[];
      discountSettingsType?: LabourDiscountType | null;
      discountSettingsValue?: number;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractLabourDiscountApiArg = {
  customerContractId: string;
  labourDiscountId: string;
};
export type DeleteCustomerContractLabourDiscountApiResponse =
  /** status 204 Standard response */ undefined;
export type DeleteCustomerContractLabourDiscountApiArg = {
  customerContractId: string;
  labourDiscountId: string;
};
export type PatchCustomerContractLabourDiscountApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchCustomerContractLabourDiscountApiArg = {
  customerContractId: string;
  labourDiscountId: string;
  body: {
    name: string;
    vehicleMakes?: (string | null)[];
    vehicleModelFamilies?: (string | null)[];
    vehicleModels?: (string | null)[];
    vehicleTypes?: (string | null)[];
    vehicleAgeType: VehicleAgeType;
    vehicleAgeFrom?: number | null;
    vehicleAgeTo?: number | null;
    workTypes?: (string | null)[];
    serviceOrderVariantIds?: (string | null)[];
    discountSettingsType: string;
    discountSettingsValue?: number | null;
  } | null;
};
export type MaterialDiscountType =
  | 'DISCOUNT_CUSTOMER_GROUP'
  | 'DISCOUNT_SALE_PRICE'
  | 'DISCOUNT_MARGIN_PURCHASE_PRICE';
export type PostCustomerContractMaterialDiscountApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCustomerContractMaterialDiscountApiArg = {
  customerContractId: string;
  body: {
    name: string;
    vehicleMakes?: (string | null)[];
    vehicleModelFamilies?: (string | null)[];
    vehicleModels?: (string | null)[];
    vehicleTypes?: (string | null)[];
    vehicleAgeType: VehicleAgeType;
    vehicleAgeFrom?: number | null;
    vehicleAgeTo?: number | null;
    isServiceOrderVariant?: boolean | null;
    serviceOrderVariantIds?: (string | null)[];
    isDirectSaleVariant?: boolean | null;
    directSaleVariantIds?: (string | null)[];
    sparePartManufacturers?: (string | null)[];
    treeFolderIds?: string[];
    discountSettingsType: string;
    discountSettingsValue?: number | null;
  } | null;
};
export type GetCustomerContractMaterialDiscountApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      customerContractId?: string | null;
      name?: string | null;
      vehicleMakes?: (string | null)[];
      vehicleModelFamilies?: (string | null)[];
      vehicleModels?: (string | null)[];
      vehicleTypes?: (string | null)[];
      vehicleAgeType?: VehicleAgeType | null;
      vehicleAgeFrom?: number | null;
      vehicleAgeTo?: number | null;
      isServiceOrderVariant?: boolean | null;
      serviceOrderVariantIds?: (string | null)[];
      isDirectSaleVariant?: boolean | null;
      directSaleVariantIds?: (string | null)[];
      sparePartManufacturers?: (string | null)[];
      treeFolderIds?: string[];
      discountSettingsType?: MaterialDiscountType | null;
      discountSettingsValue?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractMaterialDiscountApiArg = {
  customerContractId: string;
  materialDiscountId: string;
};
export type DeleteCustomerContractMaterialDiscountApiResponse =
  /** status 204 Standard response */ undefined;
export type DeleteCustomerContractMaterialDiscountApiArg = {
  customerContractId: string;
  materialDiscountId: string;
};
export type PatchCustomerContractMaterialDiscountApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchCustomerContractMaterialDiscountApiArg = {
  customerContractId: string;
  materialDiscountId: string;
  body: {
    name: string;
    vehicleMakes?: (string | null)[];
    vehicleModelFamilies?: (string | null)[];
    vehicleModels?: (string | null)[];
    vehicleTypes?: (string | null)[];
    vehicleAgeType: VehicleAgeType;
    vehicleAgeFrom?: number | null;
    vehicleAgeTo?: number | null;
    serviceOrderVariantIds?: (string | null)[];
    sparePartManufacturers?: (string | null)[];
    treeFolderIds?: string[];
    discountSettingsType: string;
    discountSettingsValue?: number | null;
  } | null;
};
export type PostCustomerContractIndividualPriceLabourApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCustomerContractIndividualPriceLabourApiArg = {
  customerContractId: string;
  body: {
    labourCatalogCategoryId: string;
    labourCatalogId: string;
    isServiceOrderVariant?: boolean | null;
    serviceOrderVariantIds?: string[];
    isDirectSaleVariant?: boolean | null;
    directSaleVariantIds?: string[];
    discountSettingsType: 'DISCOUNT_PERCENTAGE' | 'DISCOUNT_HOURLY_RATE' | 'DISCOUNT_FIXED_PRICE';
    discountSettingsValue: number;
  } | null;
};
export type GetCustomerContractIndividualPriceLabourApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      labourCatalogCategoryId?: string | null;
      labourCatalogId?: string | null;
      isServiceOrderVariant?: boolean | null;
      serviceOrderVariantIds?: string[];
      isDirectSaleVariant?: boolean | null;
      directSaleVariantIds?: string[];
      discountSettingsType?:
        | 'DISCOUNT_PERCENTAGE'
        | 'DISCOUNT_HOURLY_RATE'
        | 'DISCOUNT_FIXED_PRICE'
        | null;
      discountSettingsValue?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractIndividualPriceLabourApiArg = {
  customerContractId: string;
  individualPriceLabourId: string;
};
export type DeleteCustomerContractIndividualPriceLabourApiResponse =
  /** status 204 Standard response */ undefined;
export type DeleteCustomerContractIndividualPriceLabourApiArg = {
  customerContractId: string;
  individualPriceLabourId: string;
};
export type PatchCustomerContractIndividualPriceLabourApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchCustomerContractIndividualPriceLabourApiArg = {
  customerContractId: string;
  individualPriceLabourId: string;
  body: {
    labourCatalogCategoryId: string;
    labourCatalogId: string;
    isServiceOrderVariant?: boolean | null;
    serviceOrderVariantIds?: string[];
    isDirectSaleVariant?: boolean | null;
    directSaleVariantIds?: string[];
    discountSettingsType: 'DISCOUNT_PERCENTAGE' | 'DISCOUNT_HOURLY_RATE' | 'DISCOUNT_FIXED_PRICE';
    discountSettingsValue: number;
  } | null;
};
export type PostCustomerContractIndividualPriceMaterialApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCustomerContractIndividualPriceMaterialApiArg = {
  customerContractId: string;
  body: {
    warehouseId: string;
    articleId: string;
    isServiceOrderVariant?: boolean | null;
    serviceOrderVariantIds?: string[];
    isDirectSaleVariant?: boolean | null;
    directSaleVariantIds?: string[];
    discountSettingsType:
      | 'DISCOUNT_SALE_PRICE'
      | 'DISCOUNT_MARGIN_PURCHASE_PRICE'
      | 'DISCOUNT_FIXED_PRICE';
    discountSettingsValue: number;
  } | null;
};
export type GetCustomerContractIndividualPriceMaterialApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      warehouseId?: string | null;
      articleId?: string | null;
      isServiceOrderVariant?: boolean | null;
      serviceOrderVariantIds?: (string | null)[];
      isDirectSaleVariant?: boolean | null;
      directSaleVariantIds?: (string | null)[];
      discountSettingsType?:
        | 'DISCOUNT_SALE_PRICE'
        | 'DISCOUNT_MARGIN_PURCHASE_PRICE'
        | 'DISCOUNT_FIXED_PRICE'
        | null;
      discountSettingsValue?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractIndividualPriceMaterialApiArg = {
  customerContractId: string;
  individualPriceMaterialId: string;
};
export type DeleteCustomerContractIndividualPriceMaterialApiResponse =
  /** status 204 Standard response */ undefined;
export type DeleteCustomerContractIndividualPriceMaterialApiArg = {
  customerContractId: string;
  individualPriceMaterialId: string;
};
export type PatchCustomerContractIndividualPriceMaterialApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchCustomerContractIndividualPriceMaterialApiArg = {
  customerContractId: string;
  individualPriceMaterialId: string;
  body: {
    warehouseId: string;
    articleId: string;
    isDirectSaleVariant?: boolean | null;
    directSaleVariantIds?: string[];
    isServiceOrderVariant?: boolean | null;
    serviceOrderVariantIds?: string[];
    discountSettingsType:
      | 'DISCOUNT_SALE_PRICE'
      | 'DISCOUNT_MARGIN_PURCHASE_PRICE'
      | 'DISCOUNT_FIXED_PRICE';
    discountSettingsValue: number;
  } | null;
};
export type PostCustomerContractAssignedCustomerApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCustomerContractAssignedCustomerApiArg = {
  customerContractId: string;
  customerId: string;
};
export type GetCustomerContractAssignedCustomerApiResponse =
  | /** status 200 Standard response */ ({
      defaultValidityDate?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractAssignedCustomerApiArg = {
  customerContractId: string;
};
export type PatchCustomerContractAssignedCustomerApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchCustomerContractAssignedCustomerApiArg = {
  customerContractId: string;
  body: {
    defaultValidityDate: string;
  } | null;
};
export type GetCustomerContractAssignedCustomerValidityApiResponse =
  | /** status 200 Standard response */ ({
      validityUntil?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCustomerContractAssignedCustomerValidityApiArg = {
  customerContractId: string;
  customerId: string;
};
export type PatchCustomerContractAssignedCustomerValidityApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchCustomerContractAssignedCustomerValidityApiArg = {
  customerContractId: string;
  customerId: string;
  body: {
    validityUntil: string;
  } | null;
};
export type DeleteCustomerContractAssignedCustomerApiResponse =
  /** status 204 Standard response */ undefined;
export type DeleteCustomerContractAssignedCustomerApiArg = {
  customerContractId: string;
  customerId: string;
};
export type GetCustomerContractBasicInformationApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      name?: string | null;
      description?: string | null;
      materialDiscountGroup?: {
        id?: string | null;
        name?: string | null;
        code?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ void;
export type GetCustomerContractBasicInformationApiArg = {
  customerContractId: string;
};
export type GetCustomerContractIndividualPricesApiResponse =
  | /** status 200 Standard response */ ({
      individualPriceLabour?: ({
        id?: string | null;
        name?: string | null;
        positionNumber?: string | null;
        discountSettingsType?: {
          key?: string | null;
          name?: string | null;
        } | null;
        percentageDiscount?: number | null;
        discountedHourlyRate?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        fixedPrice?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null)[];
      individualPriceMaterial?: ({
        id?: string | null;
        name?: string | null;
        manufacturerNumber?: string | null;
        manufacturer?: string | null;
        warehouse?: string | null;
        discountSettingsType?: {
          key?: string | null;
          name?: string | null;
        } | null;
        discountOnSalePrice?: number | null;
        marginToPurchasePrice?: number | null;
        fixedPrice?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ void;
export type GetCustomerContractIndividualPricesApiArg = {
  customerContractId: string;
};
export type GetCustomerContractLabourDiscountsApiResponse =
  | /** status 200 Standard response */ ({
      labourDiscount?: ({
        id?: string | null;
        name?: string | null;
        discountSettingsType?: {
          key?: string | null;
          name?: string | null;
        } | null;
        workTypes?: ({
          key?: string | null;
          name?: string | null;
        } | null)[];
        discountedRate?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        percentageDiscount?: number | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ void;
export type GetCustomerContractLabourDiscountsApiArg = {
  customerContractId: string;
};
export type GetCustomerContractMaterialDiscountsApiResponse =
  | /** status 200 Standard response */ ({
      materialDiscount?: ({
        id?: string | null;
        name?: string | null;
        discountSettingsType?: {
          key?: string | null;
          name?: string | null;
        } | null;
        discountCustomerGroup?: number | null;
        discountOnSalePrice?: number | null;
        marginToPurchasePrice?: number | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ void;
export type GetCustomerContractMaterialDiscountsApiArg = {
  customerContractId: string;
};
export type GetCustomerContractsByCustomerIdApiResponse =
  /** status 200 Standard response */
  | ({
      customerContractId?: string | null;
      name?: string | null;
      description?: string | null;
      materialDiscountGroupId?: string | null;
      isDefault?: boolean | null;
      validityUntil?: string | null;
    } | null)[]
  | /** status 204 Standard response */ void;
export type GetCustomerContractsByCustomerIdApiArg = {
  customerId: string;
};
export type PutCustomerContractSetDefaultApiResponse = /** status 204 Standard response */ void;
export type PutCustomerContractSetDefaultApiArg = {
  customerId: string;
  customerContractId: string;
};
export type PostCustomerContractSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostCustomerContractSetActiveApiArg = {
  customerContractId: string;
};
export type PostCustomerContractSetInActiveApiResponse = /** status 204 Standard response */ void;
export type PostCustomerContractSetInActiveApiArg = {
  customerContractId: string;
};
export type PostCustomerContractCloneApiResponse = /** status 204 Standard response */ void;
export type PostCustomerContractCloneApiArg = {
  customerContractId: string;
};
